import type {
  AreaPiloto,
  QuadraPiloto,
  ArvorePiloto,
  IndicadoresPiloto,
  AreaVerdeEntorno,
  LayerToggle,
} from "@/types/piloto";

export const areaPiloto: AreaPiloto = {
  id: "floraiq-sbv-001",
  nome: "Área Piloto 01 — Setor Bela Vista",
  bairro: "Setor Bela Vista",
  municipio: "Goiânia",
  uf: "GO",
  coordenadaCentral: {
    latitude: -16.7145149,
    longitude: -49.260067,
  },
  totalQuadras: 39,
  tipoArea: "Bairro urbano consolidado",
  funcaoAmbiental: "Área de transição e possível corredor verde urbano",
  prioridadeInventario: "Alta",
  status: "Planejamento / Piloto",
  projeto: "FloraIQ",
};

export const quadras: QuadraPiloto[] = Array.from({ length: 39 }, (_, index) => {
  const n = index + 1;
  const statuses: Array<QuadraPiloto["statusLevantamento"]> = [
    "nao_iniciado",
    "em_campo",
    "processado",
    "validado",
  ];
  const prioridades: Array<QuadraPiloto["prioridadePlantio"]> = [
    "baixa",
    "media",
    "alta",
    "critica",
  ];
  const status = statuses[Math.floor(Math.random() * statuses.length)];
  const prioridade = prioridades[Math.floor(Math.random() * prioridades.length)];
  const totalArvores = status === "nao_iniciado" ? 0 : Math.floor(Math.random() * 45) + 5;
  const arvoresComRisco = totalArvores > 0 ? Math.floor(Math.random() * Math.min(6, totalArvores)) : 0;
  const arvoresComConflito = totalArvores > 0 ? Math.floor(Math.random() * Math.min(4, totalArvores)) : 0;
  const cobertura = status === "nao_iniciado" ? 0 : Math.floor(Math.random() * 35) + 5;

  const iaqs: Array<QuadraPiloto["iaq"]> = ["alta", "media", "baixa", "critica"];
  const icvs: Array<QuadraPiloto["icv"]> = ["muito_alta", "alta", "media", "baixa"];
  const ipps: Array<QuadraPiloto["ipp"]> = ["baixa", "media", "alta", "critica"];

  return {
    id: `sbv-q${String(n).padStart(3, "0")}`,
    codigo: `SBV-Q${String(n).padStart(3, "0")}`,
    nome: `Quadra ${n}`,
    areaPilotoId: "floraiq-sbv-001",
    statusLevantamento: status,
    totalArvores,
    arvoresComRisco,
    arvoresComConflito,
    prioridadePlantio: prioridade,
    coberturaCopaPercentual: cobertura,
    iaq: iaqs[Math.floor(Math.random() * iaqs.length)],
    icv: icvs[Math.floor(Math.random() * icvs.length)],
    ipp: ipps[Math.floor(Math.random() * ipps.length)],
  };
});

export const arvores: ArvorePiloto[] = [
  {
    id: "sbv-arv-001", codigo: "SBV-001", areaPilotoId: "floraiq-sbv-001", quadraId: "sbv-q001", quadraCodigo: "SBV-Q001",
    latitude: -16.7142, longitude: -49.2598, logradouro: "R. 240, Qd. 1",
    especiePopular: "Ipê Amarelo", especieCientifica: "Handroanthus chrysotrichus", familia: "Bignoniaceae",
    origem: "nativa", alturaM: 12.5, dapCm: 48.3, diametroCopaM: 8.2,
    estadoFitossanitario: "saudavel", risco: "baixo",
    interferencias: ["fiação elétrica"], manejoRecomendado: ["poda de limpeza"],
    fotos: [], dataCadastro: "2026-06-15",
  },
  {
    id: "sbv-arv-002", codigo: "SBV-002", areaPilotoId: "floraiq-sbv-001", quadraId: "sbv-q001", quadraCodigo: "SBV-Q001",
    latitude: -16.7145, longitude: -49.2602, logradouro: "R. 240, Qd. 1",
    especiePopular: "Flamboyant", especieCientifica: "Delonix regia", familia: "Fabaceae",
    origem: "exotica", alturaM: 10.0, dapCm: 35.0, diametroCopaM: 12.0,
    estadoFitossanitario: "regular", risco: "medio",
    interferencias: ["meio-fio", "passeio"], manejoRecomendado: ["poda de redução"],
    fotos: [], dataCadastro: "2026-06-15",
  },
  {
    id: "sbv-arv-003", codigo: "SBV-003", areaPilotoId: "floraiq-sbv-001", quadraId: "sbv-q002", quadraCodigo: "SBV-Q002",
    latitude: -16.7150, longitude: -49.2585, logradouro: "Av. Bela Vista, Qd. 2",
    especiePopular: "Jacarandá", especieCientifica: "Jacaranda mimosifolia", familia: "Bignoniaceae",
    origem: "nativa", alturaM: 14.0, dapCm: 55.0, diametroCopaM: 9.5,
    estadoFitossanitario: "saudavel", risco: "baixo",
    interferencias: [], manejoRecomendado: ["monitoramento"],
    fotos: [], dataCadastro: "2026-06-16",
  },
  {
    id: "sbv-arv-004", codigo: "SBV-004", areaPilotoId: "floraiq-sbv-001", quadraId: "sbv-q003", quadraCodigo: "SBV-Q003",
    latitude: -16.7158, longitude: -49.2595, logradouro: "R. 241, Qd. 3",
    especiePopular: "Figueira", especieCientifica: "Ficus benjamina", familia: "Moraceae",
    origem: "exotica", alturaM: 8.5, dapCm: 62.0, diametroCopaM: 14.0,
    estadoFitossanitario: "comprometida", risco: "alto",
    interferencias: ["raízes em passeio", "fiação elétrica", "meio-fio"], manejoRecomendado: ["poda drástica", "monitoramento"],
    fotos: [], dataCadastro: "2026-06-16",
  },
  {
    id: "sbv-arv-005", codigo: "SBV-005", areaPilotoId: "floraiq-sbv-001", quadraId: "sbv-q003", quadraCodigo: "SBV-Q003",
    latitude: -16.7162, longitude: -49.2590, logradouro: "R. 241, Qd. 3",
    especiePopular: "Mangueira", especieCientifica: "Mangifera indica", familia: "Anacardiaceae",
    origem: "exotica", alturaM: 9.0, dapCm: 42.0, diametroCopaM: 10.0,
    estadoFitossanitario: "saudavel", risco: "baixo",
    interferencias: ["edificação"], manejoRecomendado: ["poda de limpeza"],
    fotos: [], dataCadastro: "2026-06-17",
  },
  {
    id: "sbv-arv-006", codigo: "SBV-006", areaPilotoId: "floraiq-sbv-001", quadraId: "sbv-q005", quadraCodigo: "SBV-Q005",
    latitude: -16.7138, longitude: -49.2610, logradouro: "R. 242, Qd. 5",
    especiePopular: "Palmeira Imperial", especieCientifica: "Roystonea oleracea", familia: "Arecaceae",
    origem: "exotica", alturaM: 18.0, dapCm: 28.0, diametroCopaM: 3.5,
    estadoFitossanitario: "saudavel", risco: "medio",
    interferencias: ["fiação elétrica"], manejoRecomendado: ["poda de copa"],
    fotos: [], dataCadastro: "2026-06-17",
  },
  {
    id: "sbv-arv-007", codigo: "SBV-007", areaPilotoId: "floraiq-sbv-001", quadraId: "sbv-q005", quadraCodigo: "SBV-Q005",
    latitude: -16.7135, longitude: -49.2605, logradouro: "R. 242, Qd. 5",
    especiePopular: "Pau-ferro", especieCientifica: "Caesalpinia pluviosa", familia: "Fabaceae",
    origem: "nativa", alturaM: 11.0, dapCm: 38.0, diametroCopaM: 7.0,
    estadoFitossanitario: "regular", risco: "medio",
    interferencias: ["meio-fio"], manejoRecomendado: ["poda de limpeza"],
    fotos: [], dataCadastro: "2026-06-18",
  },
  {
    id: "sbv-arv-008", codigo: "SBV-008", areaPilotoId: "floraiq-sbv-001", quadraId: "sbv-q006", quadraCodigo: "SBV-Q006",
    latitude: -16.7170, longitude: -49.2580, logradouro: "Av. T-7, Qd. 6",
    especiePopular: "Aroeira", especieCientifica: "Licania tomentosa", familia: "Chrysobalanaceae",
    origem: "nativa", alturaM: 7.5, dapCm: 25.0, diametroCopaM: 6.0,
    estadoFitossanitario: "doente", risco: "alto",
    interferencias: ["passeio", "meio-fio"], manejoRecomendado: ["tratamento fitossanitário", "monitoramento"],
    fotos: [], dataCadastro: "2026-06-18",
  },
  {
    id: "sbv-arv-009", codigo: "SBV-009", areaPilotoId: "floraiq-sbv-001", quadraId: "sbv-q008", quadraCodigo: "SBV-Q008",
    latitude: -16.7180, longitude: -49.2620, logradouro: "R. 243, Qd. 8",
    especiePopular: "Ipê Roxo", especieCientifica: "Handroanthus impetiginosus", familia: "Bignoniaceae",
    origem: "nativa", alturaM: 13.0, dapCm: 50.0, diametroCopaM: 8.5,
    estadoFitossanitario: "saudavel", risco: "baixo",
    interferencias: [], manejoRecomendado: ["monitoramento"],
    fotos: [], dataCadastro: "2026-06-19",
  },
  {
    id: "sbv-arv-010", codigo: "SBV-010", areaPilotoId: "floraiq-sbv-001", quadraId: "sbv-q010", quadraCodigo: "SBV-Q010",
    latitude: -16.7125, longitude: -49.2630, logradouro: "R. 244, Qd. 10",
    especiePopular: "Pitangueira", especieCientifica: "Eugenia uniflora", familia: "Myrtaceae",
    origem: "nativa", alturaM: 5.0, dapCm: 18.0, diametroCopaM: 4.5,
    estadoFitossanitario: "saudavel", risco: "baixo",
    interferencias: [], manejoRecomendado: ["monitoramento"],
    fotos: [], dataCadastro: "2026-06-19",
  },
  {
    id: "sbv-arv-011", codigo: "SBV-011", areaPilotoId: "floraiq-sbv-001", quadraId: "sbv-q012", quadraCodigo: "SBV-Q012",
    latitude: -16.7165, longitude: -49.2570, logradouro: "Av. T-9, Qd. 12",
    especiePopular: "Oitizeiro", especieCientifica: "Schinopsis brasiliensis", familia: "Anacardiaceae",
    origem: "nativa", alturaM: 6.0, dapCm: 20.0, diametroCopaM: 5.0,
    estadoFitossanitario: "regular", risco: "medio",
    interferencias: ["passeio"], manejoRecomendado: ["poda de limpeza"],
    fotos: [], dataCadastro: "2026-06-20",
  },
  {
    id: "sbv-arv-012", codigo: "SBV-012", areaPilotoId: "floraiq-sbv-001", quadraId: "sbv-q015", quadraCodigo: "SBV-Q015",
    latitude: -16.7195, longitude: -49.2615, logradouro: "R. 245, Qd. 15",
    especiePopular: "Goiabeira", especieCientifica: "Psidium guajava", familia: "Myrtaceae",
    origem: "nativa", alturaM: 4.5, dapCm: 15.0, diametroCopaM: 4.0,
    estadoFitossanitario: "comprometida", risco: "alto",
    interferencias: ["edificação", "meio-fio"], manejoRecomendado: ["poda de redução", "tratamento fitossanitário"],
    fotos: [], dataCadastro: "2026-06-20",
  },
  {
    id: "sbv-arv-013", codigo: "SBV-013", areaPilotoId: "floraiq-sbv-001", quadraId: "sbv-q018", quadraCodigo: "SBV-Q018",
    latitude: -16.7110, longitude: -49.2585, logradouro: "R. 246, Qd. 18",
    especiePopular: "Cajueiro", especieCientifica: "Anacardium occidentale", familia: "Anacardiaceae",
    origem: "nativa", alturaM: 8.0, dapCm: 30.0, diametroCopaM: 7.5,
    estadoFitossanitario: "saudavel", risco: "baixo",
    interferencias: [], manejoRecomendado: ["monitoramento"],
    fotos: [], dataCadastro: "2026-06-21",
  },
  {
    id: "sbv-arv-014", codigo: "SBV-014", areaPilotoId: "floraiq-sbv-001", quadraId: "sbv-q020", quadraCodigo: "SBV-Q020",
    latitude: -16.7205, longitude: -49.2595, logradouro: "Av. T-11, Qd. 20",
    especiePopular: "Sibipiruna", especieCientifica: "Caesalpinia pluviosa var. peltophoroides", familia: "Fabaceae",
    origem: "nativa", alturaM: 9.5, dapCm: 32.0, diametroCopaM: 7.0,
    estadoFitossanitario: "saudavel", risco: "baixo",
    interferencias: [], manejoRecomendado: ["monitoramento"],
    fotos: [], dataCadastro: "2026-06-21",
  },
  {
    id: "sbv-arv-015", codigo: "SBV-015", areaPilotoId: "floraiq-sbv-001", quadraId: "sbv-q022", quadraCodigo: "SBV-Q022",
    latitude: -16.7120, longitude: -49.2650, logradouro: "R. 247, Qd. 22",
    especiePopular: "Murta", especieCientifica: "Myrtus communis", familia: "Myrtaceae",
    origem: "exotica", alturaM: 3.5, dapCm: 12.0, diametroCopaM: 2.5,
    estadoFitossanitario: "morta", risco: "critico",
    interferencias: ["passeio", "meio-fio"], manejoRecomendado: ["supressão", "recomposição"],
    fotos: [], dataCadastro: "2026-06-22",
  },
  {
    id: "sbv-arv-016", codigo: "SBV-016", areaPilotoId: "floraiq-sbv-001", quadraId: "sbv-q025", quadraCodigo: "SBV-Q025",
    latitude: -16.7210, longitude: -49.2640, logradouro: "R. 248, Qd. 25",
    especiePopular: "Pata-de-vaca", especieCientifica: "Bauhinia variegata", familia: "Fabaceae",
    origem: "nativa", alturaM: 6.5, dapCm: 22.0, diametroCopaM: 5.5,
    estadoFitossanitario: "regular", risco: "medio",
    interferencias: ["fiação elétrica"], manejoRecomendado: ["poda de limpeza"],
    fotos: [], dataCadastro: "2026-06-22",
  },
  {
    id: "sbv-arv-017", codigo: "SBV-017", areaPilotoId: "floraiq-sbv-001", quadraId: "sbv-q028", quadraCodigo: "SBV-Q028",
    latitude: -16.7140, longitude: -49.2660, logradouro: "Av. T-13, Qd. 28",
    especiePopular: "Ipê Branco", especieCientifica: "Tabebuia roseoalba", familia: "Bignoniaceae",
    origem: "nativa", alturaM: 11.0, dapCm: 40.0, diametroCopaM: 7.5,
    estadoFitossanitario: "saudavel", risco: "baixo",
    interferencias: [], manejoRecomendado: ["monitoramento"],
    fotos: [], dataCadastro: "2026-06-23",
  },
  {
    id: "sbv-arv-018", codigo: "SBV-018", areaPilotoId: "floraiq-sbv-001", quadraId: "sbv-q030", quadraCodigo: "SBV-Q030",
    latitude: -16.7225, longitude: -49.2575, logradouro: "R. 249, Qd. 30",
    especiePopular: "Guapuruvu", especieCientifica: "Schizolobium parahyba", familia: "Fabaceae",
    origem: "nativa", alturaM: 15.0, dapCm: 45.0, diametroCopaM: 8.0,
    estadoFitossanitario: "saudavel", risco: "baixo",
    interferencias: [], manejoRecomendado: ["monitoramento"],
    fotos: [], dataCadastro: "2026-06-23",
  },
  {
    id: "sbv-arv-019", codigo: "SBV-019", areaPilotoId: "floraiq-sbv-001", quadraId: "sbv-q032", quadraCodigo: "SBV-Q032",
    latitude: -16.7105, longitude: -49.2600, logradouro: "R. 250, Qd. 32",
    especiePopular: "Acerola", especieCientifica: "Malpighia emarginata", familia: "Malpighiaceae",
    origem: "nativa", alturaM: 3.0, dapCm: 10.0, diametroCopaM: 2.8,
    estadoFitossanitario: "saudavel", risco: "baixo",
    interferencias: [], manejoRecomendado: ["monitoramento"],
    fotos: [], dataCadastro: "2026-06-24",
  },
  {
    id: "sbv-arv-020", codigo: "SBV-020", areaPilotoId: "floraiq-sbv-001", quadraId: "sbv-q035", quadraCodigo: "SBV-Q035",
    latitude: -16.7235, longitude: -49.2625, logradouro: "Av. T-15, Qd. 35",
    especiePopular: "Grumixama", especieCientifica: "Eugenia brasiliensis", familia: "Myrtaceae",
    origem: "nativa", alturaM: 5.5, dapCm: 17.0, diametroCopaM: 4.0,
    estadoFitossanitario: "regular", risco: "medio",
    interferencias: ["passeio"], manejoRecomendado: ["poda de limpeza"],
    fotos: [], dataCadastro: "2026-06-24",
  },
];

export const indicadoresPiloto: IndicadoresPiloto = {
  totalQuadras: 39,
  totalArvores: arvores.length,
  coberturaCopaMedia: null,
  quadrasComDeficit: quadras.filter((q) => q.coberturaCopaPercentual < 10).length,
  arvoresComRisco: arvores.filter((a) => a.risco === "alto" || a.risco === "critico").length,
  arvoresComConflitoUrbano: arvores.filter((a) => a.interferencias.length > 0).length,
  prioridadeAltaPlantio: quadras.filter((q) => q.prioridadePlantio === "alta" || q.prioridadePlantio === "critica").length,
  especiesIdentificadas: new Set(arvores.map((a) => a.especieCientifica).filter(Boolean)).size,
  statusLevantamento: "Planejamento",
  quadrasEmCampo: quadras.filter((q) => q.statusLevantamento === "em_campo").length,
  quadrasProcessadas: quadras.filter((q) => q.statusLevantamento === "processado").length,
  quadrasValidadas: quadras.filter((q) => q.statusLevantamento === "validado").length,
};

export const areasVerdesEntorno: AreaVerdeEntorno[] = [
  { nome: "Jardim Botânico de Goiânia", tipo: "Parque / Área ambiental", direcao: "Sul/Sudeste", relevancia: "Alta", distanciaKm: 1.2 },
  { nome: "Parque Areião", tipo: "Parque urbano", direcao: "Norte/Nordeste", relevancia: "Alta", distanciaKm: 2.1 },
  { nome: "Parque Flamboyant", tipo: "Parque urbano", direcao: "Leste/Nordeste", relevancia: "Alta", distanciaKm: 1.8 },
  { nome: "Parque das Laranjeiras", tipo: "Área verde urbana", direcao: "Leste/Sudeste", relevancia: "Média/Alta", distanciaKm: 3.0 },
  { nome: "Praça do Sol", tipo: "Praça urbana", direcao: "Norte/Noroeste", relevancia: "Média", distanciaKm: 1.5 },
  { nome: "Áreas verdes próximas ao Estádio Serrinha", tipo: "Área institucional vegetada", direcao: "Norte/Nordeste", relevancia: "Média", distanciaKm: 2.5 },
];

export const camadasMapaPiloto: LayerToggle[] = [
  { id: "perimetro", label: "Perímetro da área piloto", ativa: true, cor: "#1B6E4F" },
  { id: "quadras", label: "Quadras", ativa: true, cor: "#0052CC" },
  { id: "arvores", label: "Árvores cadastradas", ativa: true, cor: "#2E7D32" },
  { id: "copas", label: "Copas das árvores", ativa: false, cor: "#43A047" },
  { id: "risco", label: "Risco arbóreo", ativa: true, cor: "#D32F2F" },
  { id: "deficit", label: "Déficit de arborização", ativa: false, cor: "#F57C00" },
  { id: "plantio", label: "Prioridade de plantio", ativa: false, cor: "#7B1FA2" },
  { id: "corredores", label: "Corredores verdes", ativa: false, cor: "#00897B" },
  { id: "areasverdes", label: "Áreas verdes do entorno", ativa: true, cor: "#1565C0" },
  { id: "nuvem", label: "Nuvem de pontos", ativa: false, cor: "#616161" },
];